export enum PaymentCryptoStep {
    option,
    sendPayment,
    tooMuch,
    notEnough,
}
